const logoStyle = {
  width: 20,
  height: 20,
  borderRadius: 10,
  objectFit: "contain",
};

const containerStyle = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
};

const TeamLogo = ({ name }) => {
  return (
    <div style={containerStyle}>
      <img src={name} style={logoStyle} alt="" />
    </div>
  );
};

export default TeamLogo;
